import _axios from '@/assets/utils/_axios'
import provinces from '@/assets/utils/provinces'
export default {
  /*获取数据库所有省份、市、区数组*/
  async getProvince({ commit },data) {
    let options=[];
    // let res = await _axios.post('/pc/AuthAndBind/getAllCity',data)
      switch (data.check) {
        case 1:
          options =provinces.filter(item => item.level === 1);
          options.unshift({id:'',pinyin:'',title: '全部'})
          commit('UPDATEPROVINCE',options); 
          return options;
        case 2:
          options =provinces.filter(item => item.up === data.id);
          options.unshift({id:'',pinyin:'',title: '全部'});
          commit('UPDATECITY',options); 
          return options;
        case 3:
          options =provinces.filter(item => item.up === data.id);
          // options.unshift({id:'',pinyin:'',title: '全部'});
          commit('UPDATEDISTRICT',options);
          return options;
        default: break;
      }
  },
  /*获取系统公告、交易列表*/
  async getMsgList({commit,getters},data) {
    let res = await _axios.post('/pc/Common/MsgList',{
      store_id: getters.storeInfo.storeId,
      num: 10,
      page: 1,
      msg_type:'1',
      ...data
    });
    if (res.code === '00000') commit('UPDATEMSGLIST',{
      lists:res.data.list || [],
      total:res.data.count || 0
    });
  },
  /*获取消息详情*/
  async getMsgDetail({ commit,getters},id) {
    let res = await _axios.post('/pc/Common/MsgDetail',{
      store_id: getters.storeInfo.storeId,
      msg_id:id,
    })
    if (res.code === '00000') commit('UPDATEMSGDETAIL',res.data);
  },
  /*将消息置为已读*/
  async readMsg({ dispatch },data) {
    let res = await _axios.post('/pc/Common/MsgSetRead',{
      ...data
    })
    //将全部消息置为已读时，重新拉取消息列表和更新头部未读消息总数
    if (res.code === '00000') {
      dispatch('getWaitHandleData');
      // dispatch('getUserHead');
      dispatch('getMsgList',{msg_type:data.msg_type});
    }
  },
  
}
